export const AUTH_TOKEN = 'auth_token'
export const AUTH_REFRESH_TOKEN = 'auth_refresh_token'